import React, { FC, ReactNode } from 'react';
import { Theme as ThemeType } from '../../../../types';
import { useConfig } from '../../../../selectors';
import { getCldImageSizeTransformation, getCldImageUrl, getPublicId } from '../../../../utils';
import { MEDIUM_SELECTABLES_ITEM_CONTENT_WIDTH, MEDIUM_SELECTABLES_ITEM_CONTENT_HEIGHT } from '../../common/selectable/containers/MediumSelectabes';

export const THEME_WIDTH = MEDIUM_SELECTABLES_ITEM_CONTENT_WIDTH;
export const THEME_HEIGHT = MEDIUM_SELECTABLES_ITEM_CONTENT_HEIGHT;
const imgSizeTransformation = `${getCldImageSizeTransformation(THEME_WIDTH, THEME_HEIGHT)},c_fill`;

export interface ThemeProps {
  theme: ThemeType,
  themeIndex: number,
  children: (themeSrc: string) => ReactNode;
}

export const Theme: FC<ThemeProps> = ({ theme, themeIndex, children }) => {
  const config = useConfig();

  const firstAssetPublicId = getPublicId('asset', config, themeIndex, theme.assets[0]);
  const themeSrc = getCldImageUrl(config.cloudName, imgSizeTransformation, firstAssetPublicId);

  return <>
    {children(themeSrc)}
  </>;
};
